import React from 'react';
import { useLocation } from 'react-router-dom';
import Page from '../../layout/Page';
import Deals from './Deals';
import PushNotifications from './PushNotifications';
import LoyaltyPoints from './LoyaltyPoints';
import ReferralProgram from './ReferralProgram';
import BirthdayClub from './BirthdayClub';
import AirPay from './AirPay';
import GiftEmail from './GiftEmail';
import Locations from './Locations';
import Settings from './Settings';
import PageBreak from '../../layout/PageBreak';
import PromoCodes from './PromoCodes';
import { userRoles } from '../../RoleProtected';
import { Features, HasFeature } from '../../RequireFeature';
import Button from '../../forms/Button';
import ModalFactory from '../../Modal';
import HamQuest from '../../api/HamQuestGiver';
import { QuestRoute } from '../../api/QuestRoutes';
import Surveys  from './Surveys';
import PointsAwards from './PointsAwards';
import { findMenuLabelByPath } from '../../../constants/InitialMenu';

export const releaseAllDeviceIDs = () => {
    ModalFactory.confirmAndProcess({
        confirmation: {
            type: 'warning',
            title: 'Warning',
            body: 'You are about to release the device IDs across all mobile app users, are you sure?',
            slideToAccept: true,
        },
        promise: {
            title: 'Releasing',
            body: 'Releasing all device IDs',
            callback: () => HamQuest.delete(QuestRoute.settings.deleteDeviceIDs)
        },
        confirmed: {
            title: 'Released',
            body: 'All device IDs successfully released',
        }
    })
}

const Mobile = ({ ...props }) => {
    const hasAwardEnhancement = HasFeature(Features.AwardEnhancement);
    const location = useLocation();
    const title = findMenuLabelByPath(location.pathname + (location.hash || '#Deals')) || 'Mobile App';
    const isPushNotificationsTab = (location.hash || '').toLowerCase() === '#pushnotifications';

    return (
        <Page
            title={title}
            icon='mobile'
            controls={!isPushNotificationsTab && <Button roles={userRoles.admin} onClick={releaseAllDeviceIDs}>Release All Device IDs</Button>}
            tabs
        >
            <Deals tab='Deals' soloTab/>
            <PromoCodes tab='Promo Codes' soloTab/>
            <PushNotifications tab='Push Notifications' roles={userRoles.notifications} soloTab/>
            {
                hasAwardEnhancement
                    ? <PointsAwards tab='Loyalty Point Awards' roles={userRoles.accountConfiguration} soloTab/>
                    : <LoyaltyPoints tab='Loyalty Points' roles={userRoles.accountConfiguration} soloTab/>
            }
            <ReferralProgram tab='Referral Program' roles={userRoles.accountConfiguration} soloTab/>
            <BirthdayClub tab='Birthday Club' roles={userRoles.accountConfiguration} soloTab/>
            <AirPay tab='AirPAY' roles={userRoles.accountConfiguration} soloTab/>
            <GiftEmail tab='Gift Email Details' roles={userRoles.accountConfiguration} soloTab/>
            <Locations tab='Locations' roles={userRoles.accountConfiguration} soloTab/>
            <Settings tab='Settings' roles={userRoles.accountConfiguration} soloTab/>
            <Surveys tab='Survey Results' soloTab />
        </Page >
    );
}

export default Mobile;